import { getPath } from '@/router/common'

const baseUrl = {
  title: '回单签收',
  path: 'SignTheReceipt'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'SignTheReceipt',
    component: () => import(/* webpackChunkName: "SignTheReceipt" */ '@/views/receiptManagement/signTheReceipt/index.vue'),
    meta: {
      title: '回单签收'
    }
  }
]
